import { render, staticRenderFns } from "./BookDetail.vue?vue&type=template&id=58b074c6&"
import script from "./BookDetail.vue?vue&type=script&lang=js&"
export * from "./BookDetail.vue?vue&type=script&lang=js&"
import style0 from "./BookDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports